export const loginConfig = {
  sections: [
    {
      title: "Login your Account",
      fields: [
        {
          type: "text",
          name: "mobileno",
          label: "Email or Phone:",
          required: true,
        },
        {
          type: "password",
          name: "password",
          label: "Password",
          required: true,
        },
      ],
    },
  ],
};
